import { ITutorRequest } from '@wot/typings';

export default function TutorReviewProgress({ tutor }: { tutor: ITutorRequest }) {
  return (
    <div className="relative w-full max-w-2xl mx-auto flex items-center justify-center gap-8 py-4">
      <div className="absolute left-0 w-full h-[1px] bg-black/50 z-10"></div>
      <ProgressItem
        stepNo={1}
        label="Personal Details"
        complete={tutor.personal.status === 'verified'}
        error={tutor.personal.status === 'issue'}
        pending={tutor.personal.status === 'pending'}
      />
      <ProgressItem
        stepNo={2}
        label="Education"
        complete={tutor.education.status === 'verified'}
        error={tutor.education.status === 'issue'}
        pending={tutor.education.status === 'pending'}
      />
      <ProgressItem
        stepNo={3}
        label="Experience"
        complete={tutor.experience.status === 'verified'}
        error={tutor.experience.status === 'issue'}
        pending={tutor.experience.status === 'pending'}
      />
      <ProgressItem
        stepNo={4}
        label="Profession"
        complete={tutor.profession.status === 'verified'}
        error={tutor.profession.status === 'issue'}
        pending={tutor.profession.status === 'pending'}
      />
    </div>
  );
}

function ProgressItem({
  stepNo,
  label,
  complete,
  error,
  pending
}: {
  stepNo: number;
  label: String;
  complete: boolean;
  error?: boolean;
  pending: boolean;
}) {
  return (
    <div className="w-full flex items-center justify-center gap-2 z-20 bg-white">
      <div
        className={`w-6 h-6 ${complete && 'bg-green-200 text-green-700'} ${
          error && 'bg-red-200 text-red-700'
        }  bg-secondary text-white text-sm p-2 rounded-full flex items-center justify-center`}
      >
        {stepNo}
      </div>
      <p className="text-sm font-semibold">{label}</p>
    </div>
  );
}
